import MobileMenu from './MobileMenu';
import { connect } from 'react-redux';
import { LOGIN_STATE } from '../../constants';
import { loginStateSelector, userSelector } from '../../selectors';

export function mapStateToProps(state) {
    const loginState = loginStateSelector(state);
    const hardOrSoftLoggedIn = loginState === LOGIN_STATE.LoggedIn || loginState === LOGIN_STATE.SoftLoggedIn;
    return {
        signedIn: hardOrSoftLoggedIn,
        user: userSelector(state),
    };
}

export default connect(mapStateToProps)(MobileMenu);
